import React from "react";
import { Constants } from "../../CommonMethhods/Constants";

function FromdateComponent(props) {
  const fromDate = props.fromDate;
  const formatDate = props.formatDate;
  const DateReverse = props.DateReverse;
  const errorResponse = props.errorResponse;
  const calanderIcon = props.clientWiseReportForCustomCalanderIcon;
  const inputWidth = props.inputWidth;
  // const minDate = props?.minDate;

  return (
    <>
      <div className="form-group calendar-icon">
        <label className="form-label">{Constants.From_Date}<span style={{ color: "red" }}>*</span></label>
        <input
          type="date"
          placeholder="DD/MM/YYYY"
          className={`${inputWidth === "custom" ? "report-custom-select personalised-select" : "datepicker form-control"}`}
          id="FromDateCombine"
          onChange={fromDate}
          defaultValue={formatDate}
          max={DateReverse}
          onInvalid={(e) => {
          e.preventDefault();
          e.target.setCustomValidity("");
        }}
          // min={minDate}
        />
         <span className="to-date-error">{errorResponse}</span>
        {calanderIcon && <span className="icon-calendar ico"></span>}
      </div>
    </>
  );
}
export default FromdateComponent;
